import { createFileRoute } from "@tanstack/react-router";
import { optionParam } from "@/utils/searchParams";
import { requireUnitAdmin } from "@/utils/route-guards";
import { EMAIL_TEMPLATE_TYPES } from "@/shared/emailTemplates";

// Which template is open lives in the URL, so leaving the page and coming back
// reopens the one the admin was editing (NAV-45). The first template of the
// first group is what the page opens on, and it stays out of the URL like every
// other default.
const TEMPLATE_TYPES = EMAIL_TEMPLATE_TYPES.map((config) => config.type);

export type EmailTemplatesSearch = {
  type?: string;
};

export const Route = createFileRoute("/bu-admin/email-templates")({
  // The unit's templates are the unit's admin's (ADR 0025 decision 4).
  beforeLoad: ({ context }) => {
    requireUnitAdmin(context);
  },
  validateSearch: (search: Record<string, unknown>): EmailTemplatesSearch => ({
    type: optionParam(TEMPLATE_TYPES, search.type),
  }),
});
